import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReportTableService } from '../reports/view/reports-view.service';
import { PrintService } from '../print-layout/print.service';
import { DateParaService } from '../reports/dateparameter/dateparameter-para.service';
import { HttpClient } from '@angular/common/http';
import { ClinicalLeadersTeams, ClinicalLeadersTeamslink } from '../reports/view/reports-view.model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-clinicalleadersteamslink',
  templateUrl: './clinicalleadersteamslink.component.html',
  styleUrls: ['./clinicalleadersteamslink.component.scss']
})
export class ClinicalleadersteamslinkComponent implements OnInit {

  rowIds: string[];
  rowId:number; 
  fetch: any[] = [];
  print:string;
    isPrint=false;
    clinicalleadersteamslink: ClinicalLeadersTeamslink[] = []
  

  constructor(private route: ActivatedRoute, private clincalleadersteamsprintService:ReportTableService,
      private printService: PrintService, private dateParaService:DateParaService,
      private http: HttpClient, private toastr: ToastrService,) { 
        this.rowIds = route.snapshot.params['Id']
        .split(',');
        this.rowId = +this.rowIds[0];
        console.log(this.rowId);
      }
        // this.print= String(this.rowIds[1]);
        // this.rowIds = route.snapshot.params['Id']
        // .split(',');
        // this.rowId = +this.rowIds[0]; 
        // console.log(this.rowId);} 
        // this.rowIds = route.snapshot.params['Id']
        // .split(',');
        // this.rowId = +this.rowIds[0]; 
        // console.log(this.rowId);

  ngOnInit() {
    { 
      this.clincalleadersteamsprintService.getClinicalLeadershipLinkTeamsList(Number(this.rowId))
      // this.supervisoryagreementprintService.getRecruitsSupervisoryAgreementList()
      .toPromise()
      .then(res => {
        this.clinicalleadersteamslink = res;
        console.log(res);
        // Check if there is data to display
        if (this.clinicalleadersteamslink.length > 0) {
          this.isPrint = true; // Enable data display
          // Comment out or remove this print-related line if you don't want the print functionality
          // this.printService.onDataReady(true,'Which clinician is allocated to work at a specific health center?')
          
          setTimeout(() => {
            this.isPrint = false; // Show the div again after setting it to true
          }, 100);
        } else {
          this.toastr.error('No data to display', '');
          // Remove the print functionality related line as well
          // this.printService.onDataReady(true,'Which clinician is allocated to work at a specific health center?','pdf','',1)
        }
      })
      .catch(err => { console.log(err); });
       
     }

  }

}
